import Heading from "components/Heading/Heading";
import ModalFirstTime from "./Modal/ModalContracting";
import TableFirstTime from "./TableContracting";

function IndexContracting() {
  return (
    <>
      <Heading name={"اكواد المقاولين"} />
      <div className="mt-5"></div>
      <ModalFirstTime />
      {/* جدول عرض البيانات وعمل الاحداث علي البيانات */}
      <TableFirstTime />
    </>
  );
}

export default IndexContracting;
